/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GroupSearch,
  ErrorInfo,
  GroupSearchConditions,
  BinaryFile,
  CompanyTrees,
  PostOrganizationsCheckBody,
  TeamTrees,
  GetOrganizationsTeamsParams
} from '.././model'


/**
 * グループ検索

 * @summary グループ検索
 */
export const postOrganizationsSearch = (
    groupSearchConditions: GroupSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GroupSearch>> => {
    return axios.post(
      `/organizations/search`,
      groupSearchConditions,options
    );
  }



    export type PostOrganizationsSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postOrganizationsSearch>>>
    export type PostOrganizationsSearchMutationBody = GroupSearchConditions
    export type PostOrganizationsSearchMutationError = AxiosError<ErrorInfo>

    export const usePostOrganizationsSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOrganizationsSearch>>, TError,{data: GroupSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postOrganizationsSearch>>, {data: GroupSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postOrganizationsSearch(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postOrganizationsSearch>>, TError, {data: GroupSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 組織情報ダウンロード

 * @summary 組織情報ダウンロード
 */
export const getOrganizationsDownload = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/organizations/download`,options
    );
  }


export const getGetOrganizationsDownloadQueryKey = () => [`/organizations/download`];

    
export type GetOrganizationsDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationsDownload>>>
export type GetOrganizationsDownloadQueryError = AxiosError<ErrorInfo>

export const useGetOrganizationsDownload = <TData = Awaited<ReturnType<typeof getOrganizationsDownload>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationsDownload>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationsDownloadQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationsDownload>>> = ({ signal }) => getOrganizationsDownload({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getOrganizationsDownload>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 組織表示

 * @summary 組織表示
 */
export const getOrganizations = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CompanyTrees>> => {
    return axios.get(
      `/organizations`,options
    );
  }


export const getGetOrganizationsQueryKey = () => [`/organizations`];

    
export type GetOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizations>>>
export type GetOrganizationsQueryError = AxiosError<ErrorInfo>

export const useGetOrganizations = <TData = Awaited<ReturnType<typeof getOrganizations>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizations>>> = ({ signal }) => getOrganizations({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 組織更新

 * @summary 組織更新
 */
export const postOrganizationsUpdate = (
    companyTrees: CompanyTrees, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/organizations/update`,
      companyTrees,options
    );
  }



    export type PostOrganizationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postOrganizationsUpdate>>>
    export type PostOrganizationsUpdateMutationBody = CompanyTrees
    export type PostOrganizationsUpdateMutationError = AxiosError<ErrorInfo>

    export const usePostOrganizationsUpdate = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOrganizationsUpdate>>, TError,{data: CompanyTrees}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postOrganizationsUpdate>>, {data: CompanyTrees}> = (props) => {
          const {data} = props ?? {};

          return  postOrganizationsUpdate(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postOrganizationsUpdate>>, TError, {data: CompanyTrees}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 非表示にできるかのチェック

 * @summary 非表示にできるかのチェック（編集ロックがないと意味がない…）
 */
export const postOrganizationsCheck = (
    postOrganizationsCheckBody: PostOrganizationsCheckBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/organizations/check`,
      postOrganizationsCheckBody,options
    );
  }



    export type PostOrganizationsCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postOrganizationsCheck>>>
    export type PostOrganizationsCheckMutationBody = PostOrganizationsCheckBody
    export type PostOrganizationsCheckMutationError = AxiosError<ErrorInfo>

    export const usePostOrganizationsCheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOrganizationsCheck>>, TError,{data: PostOrganizationsCheckBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postOrganizationsCheck>>, {data: PostOrganizationsCheckBody}> = (props) => {
          const {data} = props ?? {};

          return  postOrganizationsCheck(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postOrganizationsCheck>>, TError, {data: PostOrganizationsCheckBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ユーザー編集用組織情報取得

 * @summary ユーザー編集用組織情報取得
 */
export const getOrganizationsTeams = (
    params?: GetOrganizationsTeamsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TeamTrees>> => {
    return axios.get(
      `/organizations/teams`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOrganizationsTeamsQueryKey = (params?: GetOrganizationsTeamsParams,) => [`/organizations/teams`, ...(params ? [params]: [])];

    
export type GetOrganizationsTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationsTeams>>>
export type GetOrganizationsTeamsQueryError = AxiosError<ErrorInfo>

export const useGetOrganizationsTeams = <TData = Awaited<ReturnType<typeof getOrganizationsTeams>>, TError = AxiosError<ErrorInfo>>(
 params?: GetOrganizationsTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationsTeams>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationsTeamsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationsTeams>>> = ({ signal }) => getOrganizationsTeams(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getOrganizationsTeams>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

